import type { Inventory, Product } from "@shared/types/ProductLine";

export const filterProductListSkuItems = (
  productInventoryData: Product[],
  searchInventory: Inventory[]
) => {
  if (!productInventoryData?.length) return [];

  // Filter the results from Product Lines Show to only include Product Inventory that exists in the Search Service results
  productInventoryData = productInventoryData?.filter((pi: Product) =>
    searchInventory.find((si: Inventory) => si.id == pi.inventory_id && si.product_id == pi.id)
  );

  return productInventoryData;
};

export const sortProductListSkuItems = (skuItems: Product[]) => {
  if (!skuItems?.length) return [];

  // First group all the inventory records by Product Id
  const skuItemsGroupedByProductId = skuItems.reduce(
    (a, b, i) => ((a[b.id] = a[b.id] || []).push(b), a),
    {}
  );

  // Then create an array of arrays containing the product id, a boolean indicating if any of the product
  // inventories were recently ordered, and the sum of times ordered count from the product inventories.
  let productSortableData = [];
  for (let productId in skuItemsGroupedByProductId) {
    const productInventories = skuItemsGroupedByProductId[productId];

    const anyInventoryRecentlyOrdered = !!productInventories.filter(i => i.recently_ordered).length;
    const sumOfTimesOrderedCount = productInventories.reduce(
      (a, b) => a + b.times_ordered_count,
      0
    );

    productSortableData.push([productId, anyInventoryRecentlyOrdered, sumOfTimesOrderedCount]);
  }

  // Then sort the sortable arrays placing the products with any recently ordered inventory first,
  // then sort the products by the summed times ordered count of the product's inventories.
  const sortedGroupedProducts = productSortableData.sort((a, b) => {
    const recentlyOrderedSort = Number(b[1]) - Number(a[1]);
    const timesOrderedSort = b[2] - a[2];

    return recentlyOrderedSort || timesOrderedSort;
  });

  // Then iterate over the sorted products and retrieve all inventories for each product, then sort the product's
  //  inventories by distributor name, and then push the sorted product's inventories into the final array.
  let finalSortedProducts = [];
  sortedGroupedProducts.forEach(p => {
    const productId = p[0];

    const productInventory = skuItems.filter(s => s.id == productId);
    const productInventorySortedByDistributor = productInventory.sort((a, b) => {
      return a.distributor_info.name.localeCompare(b.distributor_info.name);
    });

    finalSortedProducts.push(...productInventorySortedByDistributor);
  });

  return finalSortedProducts;
};
